export const E_CATALOGUE_ROOT_ELEMENT_ID = 'catalogue-ipaper-root';

type PartialNextJsInfo = {
  page: string;
  query: {
    catalogueCode?: string[];
  };
};

/**
 * Legacy determination if in eCatalogue / iPaper page.
 * TODO: Remove ASAP.
 * @deprecated
 */
export function isECatalogue() {
  // Old agreed integration was to have this root element in page rendered from server.
  const isRootElement = Boolean(document.getElementById(E_CATALOGUE_ROOT_ELEMENT_ID));
  if (isRootElement) {
    return true;
  }

  // The above might not be rendered yet in page after migration to AppShell.
  // Let's try examining the NextJS serialized data then.
  // There should be serialized data similar to this:
  // "page": "/internal/[tenant]/[language]/catalogue/[...catalogueCode]",
  // "query": {
  //   "tenant": "hu",
  //   "language": "hu-HU",
  //   "catalogueCode": ["digital-catalogue-current"]
  // },
  try {
    const element = document.getElementById('__NEXT_DATA__');
    if (!element) {
      return false;
    }

    const data = JSON.parse(element.innerText) as PartialNextJsInfo;
    const {
      page,
      query: { catalogueCode },
    } = data;

    return page.includes('/internal/[tenant]/[language]/catalogue/[...catalogueCode]') && catalogueCode !== undefined;
  } catch (error) {
    return false;
  }
}
